import React, { useState } from 'react';
import { ChevronDown, Menu, X, CreditCard, Smartphone, Globe, Users, TrendingUp, Shield, Zap, CheckCircle, Star, DollarSign, PieChart, FileText, Eye, Clock, Calculator } from 'lucide-react';

export default function PettyCashLanding() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    companyName: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Demo request submitted! We will contact you soon.');
    setFormData({
      fullName: '',
      phoneNumber: '',
      email: '',
      companyName: '',
      message: ''
    });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
             <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
               <div className="flex justify-between items-center h-16">
                 <div className="flex items-center">
                   <div className="flex items-center space-x-2">
                     <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                       <span className="text-white font-bold text-sm">A</span>
                     </div>
                     {/* <span className="text-xl font-bold text-gray-900">AnviTech Solutions</span> */}
                     <img src="./logo.png" alt="AnviTech Solutions" className="w-32 h-auto" />
                   </div>
                 </div>
                 
                 <div className="hidden md:block">
                   <div className="ml-10 flex items-baseline space-x-8">
                     <div className="relative group">
                       <button className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium flex items-center">
                         PRODUCTS <ChevronDown className="ml-1 h-4 w-4" />
                       </button>
                     </div>
                     <div className="relative group">
                       <button className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium flex items-center">
                         SERVICES <ChevronDown className="ml-1 h-4 w-4" />
                       </button>
                     </div>
                     <div className="relative group">
                       <button className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-medium flex items-center">
                         ABOUT <ChevronDown className="ml-1 h-4 w-4" />
                       </button>
                     </div>
                   </div>
                 </div>
     
                 <div className="flex items-center space-x-4">
                   <button className="bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-blue-700 transition-colors">
                     LOGIN
                   </button>
                   <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                     {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                   </button>
                 </div>
               </div>
             </nav>
           </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-pink-50 via-orange-50 to-yellow-50 py-20 relative overflow-hidden">
        <div className="absolute top-10 right-10 w-20 h-20 bg-pink-200 rounded-full opacity-50"></div>
        <div className="absolute bottom-20 left-10 w-16 h-16 bg-orange-200 rounded-full opacity-60"></div>
        <div className="absolute top-1/2 right-1/4 w-12 h-12 bg-yellow-200 rounded-full opacity-40"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Experience the Future of
                <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-400">
                  Petty Cash Management
                </span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Streamline your petty cash tracking & reporting, making your day-to-day business easier. Fleet 
                OmniCard ensures you're always in control.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="bg-gradient-to-r from-pink-500 to-orange-400 text-white px-8 py-4 rounded-full text-lg font-medium hover:opacity-90 transition-opacity shadow-lg">
                  Get Started with petty cash card
                </button>
                <button className="border border-gray-300 text-gray-700 px-8 py-4 rounded-full text-lg font-medium hover:bg-gray-50 transition-colors">
                  Book a Demo
                </button>
              </div>
            </div>
            <div className="relative">
              <div className="bg-white rounded-3xl shadow-2xl p-8 transform hover:scale-105 transition-transform duration-300">
                <div className="bg-gradient-to-br from-pink-500 to-orange-400 rounded-2xl p-6 text-white mb-6">
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <div className="text-sm text-pink-200 mb-1">Available Balance</div>
                      <div className="text-3xl font-bold">₹12,500</div>
                    </div>
                    <CreditCard className="h-8 w-8" />
                  </div>
                  <div className="space-y-2 text-sm">
                    <div>XXXX XXXX XXXX 4321</div>
                    <div className="flex justify-between">
                      <span>12/28</span>
                      <span>OMNI CARD</span>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                        <TrendingUp className="h-5 w-5 text-green-600" />
                      </div>
                      <div>
                        <div className="font-medium text-gray-900">Office Supplies</div>
                        <div className="text-sm text-gray-500">Today, 2:30 PM</div>
                      </div>
                    </div>
                    <span className="text-green-600 font-semibold">-₹850</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-blue-50 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                        <Users className="h-5 w-5 text-blue-600" />
                      </div>
                      <div>
                        <div className="font-medium text-gray-900">Team Lunch</div>
                        <div className="text-sm text-gray-500">Yesterday, 1:15 PM</div>
                      </div>
                    </div>
                    <span className="text-blue-600 font-semibold">-₹2,400</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-400 mb-2">1</div>
              <div className="text-gray-600 text-sm">Create expense report in 1 minute</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-400 mb-2">15</div>
              <div className="text-gray-600 text-sm">Load in 15 seconds via doorstep</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-400 mb-2">6X</div>
              <div className="text-gray-600 text-sm">Get faster with digital expense</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-400 mb-2">20%</div>
              <div className="text-gray-600 text-sm">Save upto 20% via admin expenses</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-400 mb-2">85%</div>
              <div className="text-gray-600 text-sm">Reduce petty cash errors by 85%</div>
            </div>
          </div>
        </div>
      </section>

      {/* Revolution Section */}
      <section className="py-16 bg-gradient-to-br from-pink-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Revolutionize your Employee Expenses with</h2>
            <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-400">our All-in-one Solution</h3>
            <p className="text-gray-600 mt-4 max-w-3xl mx-auto">
              Unlock seamless expense management. Experience seamless control over 
              over 600k+ transactions, simplify reimbursements, everything 
              seamlessly into your workflow with petty cash cards.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {[
              { icon: '💳', label: 'Petty Cash Cards' },
              { icon: '📱', label: 'Mobile App' },
              { icon: '📊', label: 'Real-time Tracking' },
              { icon: '🔒', label: 'Secure Payments' },
              { icon: '📈', label: 'Analytics' },
              { icon: '⚡', label: 'Instant Reports' }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-shadow">
                <div className="text-3xl mb-3">{item.icon}</div>
                <div className="text-sm font-medium text-gray-700">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Optimize day-to-day operations and empower your employees with easy to use Solutions
            </h2>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-2xl p-8 text-center">
              <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                <FileText className="h-10 w-10 text-pink-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">EXPENSE REPORTS</h3>
              <div className="bg-white rounded-xl p-4 shadow-md">
                <div className="text-left">
                  <div className="font-bold text-lg mb-2">Paid Expense</div>
                  <div className="text-3xl font-bold text-gray-900">₹1000</div>
                  <div className="text-sm text-gray-500 mt-2">Generated automatically</div>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-8 text-center">
              <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                <CreditCard className="h-10 w-10 text-orange-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">CORPORATE CARDS</h3>
              <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-4 text-white shadow-lg">
                <div className="text-left">
                  <div className="text-sm mb-2">CORPORATE CARD</div>
                  <div className="text-lg font-mono">•••• •••• •••• 1234</div>
                  <div className="flex justify-between mt-4">
                    <span className="text-xs">12/26</span>
                    <span className="text-xs">OMNI</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 text-center">
              <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
                <Smartphone className="h-10 w-10 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">MOBILE APP</h3>
              <div className="bg-white rounded-xl p-4 shadow-md">
                <div className="space-y-2">
                  <div className="h-8 bg-pink-100 rounded flex items-center px-3">
                    <div className="w-4 h-4 bg-pink-400 rounded-full mr-2"></div>
                    <span className="text-sm">Dashboard</span>
                  </div>
                  <div className="h-8 bg-blue-100 rounded flex items-center px-3">
                    <div className="w-4 h-4 bg-blue-400 rounded-full mr-2"></div>
                    <span className="text-sm">Transactions</span>
                  </div>
                  <div className="h-8 bg-green-100 rounded flex items-center px-3">
                    <div className="w-4 h-4 bg-green-400 rounded-full mr-2"></div>
                    <span className="text-sm">Reports</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gradient-to-br from-pink-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Experience the Future of</h2>
            <h3 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-400">
              Petty Cash Management
            </h3>
          </div>
          
          <div className="space-y-12">
            <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-8 shadow-xl">
              <div className="grid lg:grid-cols-2 gap-8 items-center">
                <div>
                  <div className="flex items-center space-x-4 mb-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-2xl flex items-center justify-center">
                      <span className="text-3xl">💰</span>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">No More Cash Hassles</h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed">
                    Say goodbye to the traditional petty cash mess, lost receipts, and time-consuming reconciliation tasks. Fleet
                    OmniCard provides precise and error-free tracking of petty cash with
                    automatic expense categorization, streamlining your financial processes.
                    Effortlessly track day-to-day petty cash
                    transactions and manage expenses without
                    financial workflows.
                  </p>
                </div>
                <div className="relative">
                  <div className="bg-gradient-to-br from-yellow-100 to-orange-100 rounded-2xl p-8">
                    <div className="space-y-4">
                      <div className="bg-white rounded-xl p-4 shadow-md flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                            <CheckCircle className="h-5 w-5 text-green-600" />
                          </div>
                          <span className="font-medium">Digital Tracking</span>
                        </div>
                        <span className="text-green-600 font-bold">✓</span>
                      </div>
                      <div className="bg-white rounded-xl p-4 shadow-md flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                            <Shield className="h-5 w-5 text-blue-600" />
                          </div>
                          <span className="font-medium">Secure & Reliable</span>
                        </div>
                        <span className="text-green-600 font-bold">✓</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-8 shadow-xl">
              <div className="grid lg:grid-cols-2 gap-8 items-center">
                <div className="lg:order-2">
                  <div className="flex items-center space-x-4 mb-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-pink-400 to-purple-500 rounded-2xl flex items-center justify-center">
                      <span className="text-3xl">📊</span>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">Get rid of Scattered Spending</h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed">
                    Simplify your records and eliminate scattered
                    spending across different channels. Petty Cash
                    Management Solution. Experience ultimate
                    convenience as OmniCard brings together all
                    company petty cash spend.
                  </p>
                </div>
                <div className="lg:order-1 relative">
                  <div className="bg-gradient-to-br from-pink-100 to-purple-100 rounded-2xl p-8">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-white rounded-xl p-4 text-center shadow-md">
                        <div className="text-2xl font-bold text-pink-600">₹45K</div>
                        <div className="text-sm text-gray-600">This Month</div>
                      </div>
                      <div className="bg-white rounded-xl p-4 text-center shadow-md">
                        <div className="text-2xl font-bold text-purple-600">127</div>
                        <div className="text-sm text-gray-600">Transactions</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white/80 backdrop-blur-lg rounded-3xl p-8 shadow-xl">
              <div className="grid lg:grid-cols-2 gap-8 items-center">
                <div>
                  <div className="flex items-center space-x-4 mb-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-400 to-cyan-500 rounded-2xl flex items-center justify-center">
                      <span className="text-3xl">👁️</span>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900">Complete Control & Visibility</h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed">
                    Gain unprecedented control and transparency over
                    expenses with OmniCard, enabling effortless tracking,
                    monitoring, and management of all company
                    expenditures. Streamline your financial oversight and
                    enhance accountability with our user-friendly.
                  </p>
                </div>
                <div className="relative">
                  <div className="bg-gradient-to-br from-blue-100 to-cyan-100 rounded-2xl p-8">
                    <div className="bg-white rounded-xl p-6 shadow-lg">
                      <div className="flex items-center justify-between mb-4">
                        <h4 className="font-bold text-gray-900">Expense Overview</h4>
                        <Eye className="h-5 w-5 text-blue-600" />
                      </div>
                      <div className="space-y-3">
                        <div className="flex justify-between">
                          <span className="text-gray-600">Office Supplies</span>
                          <span className="font-semibold">₹12,500</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600">Travel</span>
                          <span className="font-semibold">₹8,750</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600">Meals</span>
                          <span className="font-semibold">₹6,200</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why OmniCard Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Why OmniCard Petty Cash Management?</h2>
          
          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-6">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-pink-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Clock className="h-8 w-8 text-pink-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">Contactless & Effortless</div>
              <div className="text-sm text-gray-600">Easy payments</div>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Shield className="h-8 w-8 text-orange-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">Bank Level Security</div>
              <div className="text-sm text-gray-600">Secure transactions</div>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Zap className="h-8 w-8 text-blue-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">On The Go Mobile App</div>
              <div className="text-sm text-gray-600">Easy third visibility</div>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="h-8 w-8 text-green-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">Easy Third Visibility</div>
              <div className="text-sm text-gray-600">Real-time insights</div>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <FileText className="h-8 w-8 text-purple-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">Best Reporting</div>
              <div className="text-sm text-gray-600">Comprehensive reports</div>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-pink-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Users className="h-8 w-8 text-pink-600" />
              </div>
              <div className="font-semibold text-gray-900 mb-2">Spend Control Support</div>
              <div className="text-sm text-gray-600">24/7 assistance</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-pink-500 to-orange-400">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-white mb-4">
                Explore Simplified <span className="underline">Petty Cash Management</span> for your Business Today
              </h2>
              <p className="text-pink-100 text-lg mb-8">
                Transform your expense management with our comprehensive solution designed for modern businesses.
              </p>
              <div className="flex items-center space-x-6">
                <div className="bg-white/20 backdrop-blur-lg rounded-2xl p-6">
                  <div className="text-3xl mb-2">📱</div>
                  <div className="text-white font-semibold">Mobile App</div>
                  <div className="text-pink-200 text-sm">iOS & Android</div>
                </div>
                <div className="bg-white/20 backdrop-blur-lg rounded-2xl p-6">
                  <div className="text-3xl mb-2">💳</div>
                  <div className="text-white font-semibold">Smart Cards</div>
                  <div className="text-pink-200 text-sm">Corporate ready</div>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-2xl">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Contact Us</h3>
                <p className="text-gray-600">Have questions? We're here to help!</p>
              </div>
              <form>
                <div className="grid grid-cols-1 gap-4">
                  <input type="text" placeholder="Your Name" className="border border-gray-300 rounded-lg p-2" />
                  <input type="email" placeholder="Your Email" className="border border-gray-300 rounded-lg p-2" />
                  <textarea placeholder="Your Message" className="border border-gray-300 rounded-lg p-2" rows="4"></textarea>
                </div>
                <button type="submit" className="mt-4 bg-pink-500 text-white rounded-lg px-4 py-2">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}